import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types';
import '../Workflow.scss'
import WorkflowTask from '../../../../../components/library/workflow-tasks/WorkflowTask'
import { useTaskStatus } from '../../hooks/useTaskStatusHook';
import { WorkflowTasks } from '../../../services/WorkflowTasks';
import WorkflowTaskDescriptionWithHelp from '../../../../../components/library/workflow-tasks/WorkflowTaskDescriptionWithHelp';
import HrbTranslate from '../../../../../components/language/HrbTranslate'
import AddOnProducts from './AddOnProducts';
import { TaskStatus } from '../../../services/TaskStatus';
import { useWorkflowState } from '../../hooks/useWorkflowStateHook';
import Button from '../../../../../components/library/buttons/Button';
import TaskErrorText from '../../../../../components/library/workflow-tasks/TaskErrorText';
import VerticalNameChildren from '../../../../../components/library/layout/VerticalNameChildren';
import EmdashText from '../../../../../components/library/common/EmdashText';
import DateTime from '../../../../../components/library/common/DateTime';
import PaymentApi from '../../../../../services/api/paymentApi';
import PrepareReturnApi from '../../../../../services/api/prepareReturnApi';
import TicketActions from '../../../../../store/ticketRedux';
import Lang from '../../../../../components/language/services/Lang'
import { useTicketState } from '../../hooks/useTicketStateHook';
import { trackEvent, HeapEvents } from '../../../../../services/util/AnalyticsUtil';
import ExtraMissingFilesError from './ExtraMissingFilesError';
import DoxExplorer from '../../dox/Explorer/doxExplorer';
import DoxUploader from '../../dox/Uploader/doxUploader';


const PaymentTask = (props) => {
    const ticketIsOpen = useTicketState(props.ticket);
    let tasks = ([WorkflowTasks.PAYMENT_RECEIVED])
    const [completion, setCompletion] = useState({})
    const [completionData, setCompletionData] = useState({})
    const [baseStatus, taskCompletions] = useTaskStatus(props.ticket, tasks);
    const [status, setStatus] = useState(baseStatus);
    const stateTasks = useWorkflowState(props.ticket);
    const [hasUploadedFiles, setHasUploadedFiles] = useState(false);
    const [uploaderOpen, setUploaderOpen] = useState(false);
    const [isCompleting, setIsCompleting] = useState(false);
    const [hasCompletionError, setHasCompletionError] = useState(false);
    const [hasUploaderError, setHasUploaderError] = useState(false);
    const [missingFiles, setMissingFiles] = useState(null);
    const [extraFiles, setExtraFiles] = useState(null)
    const [completionErrorType, setCompletionErrorType] = useState(null)
    const [explorerShowing, setExplorerShowing] = useState(false)
    const api = PaymentApi.create();
    const prepareReturnApi = PrepareReturnApi.create();
    const dispatch = useDispatch();

    const showUploader = () => {
        setUploaderOpen(true)
    }

    const handleUploaderError = () => {
        setHasUploaderError(true);
    }

    const confirmPayment = async () => {
        setIsCompleting(true)
        setHasCompletionError(false);
        var response = await api.completePaymentTask(props.ticket.id)
        if (response && response.ok) {
            if (response.data.status !== TaskStatus.COMPLETE) {
                var extraFiles = null;
                var missingFiles = null;
                if (response.data && response.data.extraFiles && response.data.extraFiles.length > 0) {
                    extraFiles = response.data.extraFiles
                }
                if (response.data && response.data.missingFiles && response.data.missingFiles.length > 0) {
                    missingFiles = response.data.missingFiles
                }
                if (extraFiles && missingFiles) {
                    setCompletionErrorType('both')
                } else if (extraFiles) {
                    setCompletionErrorType('extra')
                } else if (missingFiles) {
                    setCompletionErrorType('missing')
                } else {
                    setCompletionErrorType(null)
                }
                setExtraFiles(extraFiles)
                setMissingFiles(missingFiles)
                setHasCompletionError(true)
            } else {
                trackEvent(HeapEvents.COMPLETE_CONFIRM_PAYMENT, props.ticket.id)
            }
            dispatch(TicketActions.getTicket(props.ticket.id))
        } else {
            setHasCompletionError(true)
        }
        setIsCompleting(false)
    }

    useEffect(() => {
        let tcs = taskCompletions || []
        let completionTask = tcs.find(x => x.status !== TaskStatus.INVALID
            && x.workflowTaskId === WorkflowTasks.PAYMENT_RECEIVED)
        
        var bStatus = baseStatus;
        if (baseStatus !== TaskStatus.COMPLETE && (props.ticket)) { 
            var returnPrepared = props.ticket.taskCompletionStates.find(tcs =>
                tcs.workflowTaskId === WorkflowTasks.RETURN_PREPARED && tcs.status !== TaskStatus.INVALID)

            if (returnPrepared && returnPrepared.status === TaskStatus.COMPLETE) {
                bStatus = TaskStatus.IN_PROGRESS
            }
            if (completionTask && completionTask.status === TaskStatus.COMPLETE) {
                setCompletion(completionTask)
                var cdata = JSON.parse(completionTask.completionData)
                setCompletionData(cdata)
                bStatus = TaskStatus.COMPLETE
            }
        }

        setStatus(hasUploaderError || hasCompletionError ? TaskStatus.ERROR : bStatus);
    }, [baseStatus, hasUploaderError, stateTasks, hasCompletionError, taskCompletions])

    const createLink = (urlKey, titleKey) => (
        <a href={Lang.getCurrentValue(urlKey)}>
            <HrbTranslate text={titleKey} />
        </a>
    )

    const onUploadsComplete = async (filesWereUploaded) => {
        if (filesWereUploaded) {
            setHasUploadedFiles(true);
        }
        setUploaderOpen(false);
    }

    const onCloseUploader = () => {
        setUploaderOpen(false);
    }

    const renderTimestamp = (completion, completionData) => {
        if ((completion && completionData && completionData.PaymentDate)) {
            return <p className='p1 medium-weight'><DateTime dateAndTime value={completionData.PaymentDate} /></p>
        }
        else {
            return <p className='p1 medium-weight'><EmdashText /></p>
        }
    }

    const saveCompletion = async (payload) => {
        if (props.ticket) {
            var response = await prepareReturnApi.updatePrepareReturnTask(props.ticket.id, payload)
            if (response && response.ok) {
                dispatch(TicketActions.getTicket(props.ticket.id))
            }
        }
        setIsCompleting(false);
    }

    const savePending = () => {
        setIsCompleting(true)
    }

    return (
        <WorkflowTask status={status} taskId={WorkflowTasks.PAYMENT_RECEIVED}>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    helpKey='0ProSupport/VDOPro/PaymentReview.htm'
                    descriptions={['PaymentTask.Description']} />
            </div>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>
                    <p className='p1 medium-weight'><HrbTranslate text='PaymentTask.Step1' /></p>
                </div>
            </div>                 
            <AddOnProducts ticket={props.ticket} onSaveCompletion={saveCompletion}
                hasUploadedFiles={hasUploadedFiles} status={status}
                onSavePending={savePending}
                disabled={status === TaskStatus.NOT_STARTED || status === TaskStatus.COMPLETE || !ticketIsOpen} />
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>
                    <div className='prep-border' />
                </div>
            </div>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>
                    <p className='p1 medium-weight'><HrbTranslate text='PaymentTask.Step2' /></p>
                </div>
            </div>   
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-8'>
                    <p className='p2'>
                        <HrbTranslate text='PaymentTask.Description2' />
                    </p>
                </div>
            </div>
            {props.ticket &&
                <Fragment>
                    <div className='step-center-container'>
                        <Button
                            elementId='payment-manage-btn'
                            labelKey='DocUploadTask.ViewManage'
                            buttonStyles='secondary'
                            onClick={() => setExplorerShowing(true)}
                            disabled={status === TaskStatus.COMPLETE || !ticketIsOpen}
                        />
                        <Button
                            elementId='payment-upload-btn'
                            labelKey='PrepareTask.UploadDocs'
                            buttonStyles='secondary'
                            onClick={showUploader}
                            disabled={status === TaskStatus.NOT_STARTED || status === TaskStatus.COMPLETE || !ticketIsOpen}
                        />
                    </div>                   
                {hasUploaderError &&
                    <div className='columns prep-section'>
                        <div className='column is-10 is-offset-1'>
                            <TaskErrorText errorKey='PrepareTask.ErrorUploader' />
                        </div>
                    </div>
                    }               
                </Fragment>
            }                
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>
                    <div className='prep-border' />
                </div>
            </div>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>
                    <p className='p1 medium-weight'><HrbTranslate text='PaymentTask.Step3' /></p>
                </div>
            </div>  
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-8'>
                    <p className='p2'>
                        <HrbTranslate text='PaymentTask.Description3' />
                    </p>
                </div>
            </div>
            <div className='columns'>
                <div className='column is-10 is-offset-1'>
                    <VerticalNameChildren
                        textKey="PaymentTask.PaymentConfirmation"
                        loading={!props.ticket}>
                        {renderTimestamp(completion, completionData)}
                    </VerticalNameChildren>
                </div>
            </div>
            {props.ticket &&
                <Fragment>
                    <div className='step-center-container'>
                        <Button
                            elementId='confirm-payment-btn'
                            labelKey='PaymentTask.ConfirmPayment'
                            buttonStyles='secondary'
                            onClick={confirmPayment}
                            disabled={status === TaskStatus.NOT_STARTED || status === TaskStatus.COMPLETE || !ticketIsOpen}
                            loading={isCompleting}
                        />
                    </div>                                       
                </Fragment>
            }            
            {hasCompletionError && !completionErrorType &&
                <div className='columns prep-section'>
                    <div className='column is-offset-1 is-10'>
                        <TaskErrorText errorKey='PaymentTask.ErrorSubmit' />
                    </div>
                </div>                  
            }
            {hasCompletionError && completionErrorType &&
                <div className='columns prep-section'>
                    <div className='column is-offset-1 is-10'>
                        <ExtraMissingFilesError completionErrorType={completionErrorType}
                            extraFiles={extraFiles} missingFiles={missingFiles} task='payment'
                            params={{
                                PrepReturn: createLink('PaymentTask.PrepareReturnLink', 'PaymentTask.PrepareReturnLinkText')
                            }}
                        />
                    </div>
                </div>
            }
            {status === TaskStatus.COMPLETE && ticketIsOpen &&
                <div className='columns prep-section'>
                    <div className='column is-offset-1 is-8'>
                        <p className='p2'>
                        <HrbTranslate text='PaymentTask.ResetInstructions'
                            params={{
                                PrepReturn: createLink('PaymentTask.PrepareReturnLink', 'PaymentTask.PrepareReturnLinkText')
                            }}
                        />
                        </p>
                    </div>
                </div>
            }
            <DoxExplorer ticket={props.ticket} show={explorerShowing}
                onClose={() => setExplorerShowing(false)} />
            <DoxUploader ticket={props.ticket} show={uploaderOpen}
                onClose={onCloseUploader} layoutType={'desktop'} onUploadsComplete={onUploadsComplete} />
        </WorkflowTask>
    );
}

PaymentTask.whyDidYouRender = false;

PaymentTask.propTypes = {
    ticket: PropTypes.object
}

export default PaymentTask